import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

const LineSticker = () => {
  const { ref } = useParams();
  console.log('LineSticker')

  useEffect(() => {
      console.log('LineSuseEffectticker')

    async function fetchData() {
            console.log(ref)
      if (ref === "2025") {
        window.location.href = "https://line.me/S/sticker/31133308";
      } else {
        window.location.href = "#";
      }
    }
    fetchData();
  }, [ref]); // ✅ ใส่ ref ใน dependency

  return null; // ใช้ null แทน <></> ก็ได้
};

export default LineSticker;
